import React from 'react';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './TagItemClickable.scss';
type Props = {
  onClick: () => void;
  onDelete: () => void;
  text: string;
  className?: string;
  saving: boolean;
  editing: boolean;
};

export const TagItemClickable = ({
  onClick,
  onDelete,
  text,
  className,
  saving,
  editing,
  ...props
}: Props) => {
  const busy = saving || editing;

  return (
    <Button
      {...props}
      gray={!busy}
      green={busy}
      onClick={onClick}
      className={`tag-item-clickable ${className || ''}`}
    >
      <div className="tag-item-clickable__text">{text}</div>
      {busy ? (
        <div className="tag-item-clickable__icon" key="active">
          <i className={saving ? 'fas fa-spinner fa-pulse' : 'fas fa-edit'} />
        </div>
      ) : (
        <div
          className="tag-item-clickable__plus-icon tag-item-clickable__icon--idle"
          key="idle"
          onClick={e => {
            e.stopPropagation();
            onDelete();
          }}
        >
          +
        </div>
      )}
    </Button>
  );
};
